import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CustomGestureConfig } from './gesture-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ClarityService } from './core/services/clarity.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);
import { providePrimeNG } from 'primeng/config';
import { NgSelectConfig } from '@ng-select/ng-select';
import Material from '@primeuix/themes/material';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: false,
          css: {
            fontFamily: 'Roboto, sans-serif'
          }
        }
      },
    }),
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: CustomGestureConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    importProvidersFrom(BrowserAnimationsModule, MatDialogModule),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideAppInitializer(() => inject(ClarityService).init()),
    {
      provide: NgSelectConfig,
      useFactory: () => {
        const config = new NgSelectConfig();
        config.fixedPlaceholder = true;
        return config;
      },
    },
  ]
};
